import React, { SVGProps } from 'react';
type SVGRProps = {
  titleId?: string;
};
const SvgIcoDownload = ({ titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 32 33"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    role="img"
    aria-labelledby={titleId}
    {...props}
  >
    <title id={titleId}>Download</title>
    <path
      d="M5.142 20.986v4.571a2.286 2.286 0 0 0 2.286 2.286H24.57a2.286 2.286 0 0 0 2.286-2.286v-4.571M15.999 5.558v16m0 0L9.142 14.7M16 21.556l6.857-6.856"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export default SvgIcoDownload;
